import React from 'react';
import { Globe, ShieldCheck, BookOpenCheck } from 'lucide-react';

export default function Compliance() {
  const items = [
    {
      Ico: Globe,
      label: 'Jurisdiction',
      title: 'United States',
      desc: 'Aligns with applicable federal and state data protection and privacy laws, including the California Consumer Privacy Act (CCPA).',
    },
    {
      Ico: Globe,
      label: 'Jurisdiction',
      title: 'United Kingdom',
      desc: 'Operates in accordance with the UK GDPR and the Data Protection Act 2018.',
      extra: 'ICO Registration: ZC017470',
    },
    {
      Ico: ShieldCheck,
      label: 'Principles',
      title: 'Core commitments',
      desc: 'Data protection, transparency, auditability and regulatory compliance are embedded across ESG and climate reporting workflows.',
    },
  ];

  return (
    <section className="relative bg-[#FAFAF5] border-t border-[#E8E5DC]">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-24">
        <div className="text-center max-w-[720px] mx-auto">
          <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#1B6F5E] font-medium">
            Compliance, security & trust
          </div>
          <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.06] text-[#0B1F2D]">
            Foundations for regulated work
          </h2>
          <p className="mt-5 text-[15px] leading-[1.6] text-[#0B1F2D]/65">
            Built with a strong foundation in data protection, regulatory alignment, and secure infrastructure
            supporting organizations operating across multiple jurisdictions.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((it) => (
            <div
              key={it.title}
              className="rounded-2xl border border-[#E8E5DC] bg-white p-7 lg:p-8"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#E8F3EE] text-[#1B6F5E] flex items-center justify-center">
                  <it.Ico className="w-4.5 h-4.5" />
                </div>
                <span className="text-[11px] uppercase tracking-[0.12em] text-[#0B1F2D]/55">{it.label}</span>
              </div>
              <div className="mt-5 font-display text-[24px] leading-[1.15] text-[#0B1F2D]">{it.title}</div>
              <p className="mt-3 text-[14px] leading-[1.6] text-[#0B1F2D]/65">{it.desc}</p>
              {it.extra && (
                <div className="mt-4 font-mono-tight text-[12px] text-[#0B1F2D]/55">{it.extra}</div>
              )}
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-[12.5px] leading-[1.6] text-[#0B1F2D]/55 max-w-[760px] mx-auto">
          Supporting compliance, legal, ESG, and risk teams with a secure, structured environment for regulatory
          compliance evaluation.
        </p>
      </div>
    </section>
  );
}
